goog.provide("shadow.js.shim.module$$tanstack$react_table");
goog.provide("module$shadow_js_shim_module$$tanstack$react_table");
shadow.js.shim.module$$tanstack$react_table = shadow.js.nativeProvides["@tanstack/react-table"] = shadow$bridge("@tanstack/react-table");
module$shadow_js_shim_module$$tanstack$react_table.default = shadow.js.shim.module$$tanstack$react_table;
